import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const Layout = ({ toggleUserInfoModal }) => {
  const { logout, userInfo, email } = useAuth();

  return (
    <>
      <Header logout={logout} userInfo={userInfo} toggleUserInfoModal={toggleUserInfoModal} />
      <Sidebar email={email} />
      <div className="main-content">
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
